var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedBasicPowerStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 66,
    viewBox: "0 0 48 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1C11.2422 1 1 11.9499 1 25.1652C1 38.3805 24 65 24 65C24 65 47 38.5693 47 25.1652C47 11.7611 36.5781 1 24 1Z",
    fill: "#FF6669",
    stroke: "#FF6669",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBasicPowerStation);
export default __webpack_public_path__ + "static/media/selected-basic-power-station.833ca82fb712dd4671fc93a05d7948f5.svg";
export { ForwardRef as ReactComponent };